import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom";

import './App.css';
import Login from './components/Login';
import SDKWrapper from './components/SDKPanel';

import { SDKContext } from './context/sdk';

function App() {
  const [components, setComponents] = useState<any>(null);
  const [design, setDesign] = useState<any>(null);
  const [error, setError] = useState<any>(null);
  const [sdk, setSDK] = useState<any>(null);
  const [viewToggles, setViewToggles] = useState<any>(null);
  return (
      <SDKContext.Provider value={{
        components,
        design,
        error,
        setDesign,
        setError,
        sdk,
        setComponents,
        setSDK,
        viewToggles,
        setViewToggles,
      }}>
        <Router>
          <div className="App">
            <h3>SDK Demo App</h3>
            <Switch>
              <Route exact path="/" component={Login} />
              <Route exact path="/sdk" component={SDKWrapper} />
              <Route path="*"><span>Page not found</span></Route>
            </Switch>
          </div>
        </Router>
      </SDKContext.Provider>
  );
}

export default App;
